document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeModule_LoginDrawer", () => {
    return {
      init() {
        initTeleport(this.$root);
        Alpine.store("modals").register("login", "rightDrawer");
      },
    };
  });
});
